import React from "react";
import { Gpt55Section } from "./sections/Gpt55Section";
import { AppleIos27Section } from "./sections/AppleIos27Section";
import { GeminiSection } from "./sections/GeminiSection";
import { QueSignificaSection } from "./sections/QueSignificaSection";

export function ArticleContent() {
  return (
    <div className="prose prose-lg prose-invert max-w-none">
      <Gpt55Section />
      <AppleIos27Section />
      <GeminiSection />
      <QueSignificaSection />
    </div>
  );
}
